const validateH5P = (zip) => {
  const promises = [];
  let h5pJson = false;
  let contentJson = false;

  zip.forEach(async (path) => {
    if (path.match('h5p.json') || path.match('content.json'))
      promises.push(zip.file(path).async('string'));
  });

  return Promise.all(promises).then((result) => {
    if (result.length !== 2) return false;

    result.forEach((arr) => {
      const json = JSON.parse(arr);

      // h5p.json file is here
      if (
        json.title &&
        json.mainLibrary &&
        json.language &&
        json.preloadedDependencies &&
        json.embedTypes
      )
        h5pJson = true;

      // content data
      if (json && !json.title) contentJson = true;
    });

    return h5pJson && contentJson;
  });
};

export default validateH5P;
